import { Component, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { MonitorPolicy, MonitorSettings_SnmpIf } from 'DiscoveryEngine.TS/Monitors';
import { MonitorConfigComponentBase } from '../MonitorConfigComponentBase';


@Component({
	selector: 'snmpif-settings',
	templateUrl: './snmpifsettings.component.html',
	styleUrls: ['./snmpifsettings.component.scss']
})
export class SnmpIfSettingsComponent extends MonitorConfigComponentBase implements OnInit, OnChanges, OnDestroy {

	public name: UntypedFormControl;
	public enabled: UntypedFormControl;
	public verifyDown: UntypedFormControl;
	public useThresholds: UntypedFormControl;
	public criticalThreshold: UntypedFormControl;
	public warningThreshold: UntypedFormControl;

	constructor(private fb: UntypedFormBuilder) {
		super();
	}

	public ngOnInit(): void {
		this.BuildForm();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public ngOnDestroy(): void {
		return;
	}

	public BuildForm(): void {
		let name = "";
		let enabled = false;
		let verifyDown = false;
		let useThresholds = false;
		let criticalThreshold = 0;
		let warningThreshold = 0;

		if (!!this.editor && this.editor.HasPolicy) {
			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_SnmpIf = <MonitorSettings_SnmpIf>monPolicy.Settings;

			name = monPolicy.Name;
			enabled = monPolicy.Enabled;
			verifyDown = !monSettings.VerifyUp;
			useThresholds = monSettings.UseThresholds;
			criticalThreshold = monSettings.CriticalThreshold;
			warningThreshold = monSettings.WarningThreshold;
		}

		this.name = new UntypedFormControl(name, Validators.required);
		this.enabled = new UntypedFormControl(enabled);
		this.verifyDown = new UntypedFormControl(verifyDown);
		this.useThresholds = new UntypedFormControl(useThresholds);
		this.criticalThreshold = new UntypedFormControl(criticalThreshold, Validators.compose([Validators.required, this.minValue(0), this.maxValue(1000000)]));
		this.warningThreshold = new UntypedFormControl(warningThreshold, Validators.compose([Validators.required, this.minValue(0), this.maxValue(1000000)]));

		this.enableDisableControls();

		this.SettingsForm = this.fb.group({
			name: this.name,
			enabled: this.enabled,
			verifyDown: this.verifyDown,
			useThresholds: this.useThresholds,
			criticalThreshold: this.criticalThreshold,
			warningThreshold: this.warningThreshold,
		},
		{
			validator: Validators.compose([
				this.validThresholds(this.criticalThreshold, this.warningThreshold),
			])
		});
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.criticalThreshold, this.thresholdsEnabled);
		this.enableDisableFormControl(this.warningThreshold, this.thresholdsEnabled);
	}

	private validThresholds(criticalThreshold: UntypedFormControl, warningThreshold: UntypedFormControl): ValidatorFn {
		return () => {
			if (criticalThreshold.value < warningThreshold.value) {
				return {
					validThresholds: { valid: false }
				};
			}
			else {
				return null;
			}
		}
	}

	public get thresholdsEnabled(): boolean {
		return (this.useThresholds.value === true);
	}

	public applyTempChanges(): void {
		if (!!this.editor && this.editor.HasPolicy) {

			let monPolicy: MonitorPolicy = this.editor.Policy;
			let monSettings: MonitorSettings_SnmpIf = <MonitorSettings_SnmpIf>monPolicy.Settings;

			monPolicy.Name = this.name.value;
			monPolicy.Enabled = this.enabled.value;
			monSettings.VerifyUp = !this.verifyDown.value;
			monSettings.UseThresholds = this.useThresholds.value;
			monSettings.CriticalThreshold = this.criticalThreshold.value;
			monSettings.WarningThreshold = this.warningThreshold.value;

			this.BuildForm();
		}
	}

	public get invalidTempChanges(): string[] {
		return ["Settings"];
	}
}
